import { Link } from "react-router-dom";
import MindFood from "../assets/MindFood_dB.svg";

export default function Navbar() {
  const Nav = {
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const Logo = {
    margin: "30px",
    height: "100px",
    marginLeft: "100px",
  };
  const Links = {
    margin: "30px",
    marginRight: "100px",
    padding: "10px",
    backgroundColor: "#ff6600",
    borderRadius: "10px",
  };
  return (
    <>
      <nav style={Nav}>
        <Link to="/">
          <img src={MindFood} style={Logo} alt="MindFood logo" />
        </Link>
        <div>
          <Link to="/auth/login" style={Links}>
            Login
          </Link>
          <Link to="/auth/forms" style={Links}>
            Sign up
          </Link>
        </div>
      </nav>
    </>
  );
}
